import { useTheme } from "../../styles/theme";
import { useApp } from "../../context/AppContext";
import { dispDate } from "../../utils/dates";
import { fmt } from "../../utils/format";
import SectionTitle from "../../components/SectionTitle";
import Field from "../../components/Field";

export default function Sales() {
  const S = useTheme();
  const { data, form, setForm, TODAY, addSale, del } = useApp();

  return (
    <div>
      <SectionTitle>Record Sale (Instant Payment)</SectionTitle>

      {/* Add form */}
      <div style={S.formCard}>
        <div style={S.formGrid}>
          <Field label="Client Name">
            <input style={S.input} placeholder="e.g. ABC Company"
              value={form.client || ""}
              onChange={e => setForm({ ...form, client: e.target.value })} />
          </Field>
          <Field label="Product / Service">
            <input style={S.input} placeholder="What was sold?"
              value={form.desc || ""}
              onChange={e => setForm({ ...form, desc: e.target.value })} />
          </Field>
          <Field label="Amount (₹)">
            <input style={S.input} type="number" placeholder="0"
              value={form.amount || ""}
              onChange={e => setForm({ ...form, amount: e.target.value })} />
          </Field>
          <Field label="Sale Date">
            <input style={S.input} type="date"
              value={form.saleDate || TODAY}
              onChange={e => setForm({ ...form, saleDate: e.target.value })} />
          </Field>
        </div>
        <div style={{ ...S.creditNote, borderLeftColor: S.colors.primary }}>
          💵 Client pays <strong>same day</strong> — cash in hand immediately
        </div>
        <button style={{ ...S.submitBtn, background: S.colors.primary }} onClick={addSale}>
          + Add Sale
        </button>
      </div>

      {/* History table */}
      <SectionTitle style={{ marginTop: 24 }}>Sales History</SectionTitle>
      <div style={S.tableWrap}>
        <table style={S.table}>
          <thead>
            <tr>
              {["Client","Description","Amount","Date","Action"].map(h => (
                <th key={h} style={S.th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.sales.length === 0 && (
              <tr><td colSpan={5} style={S.emptyCell}>No sales yet.</td></tr>
            )}
            {data.sales.map(s => (
              <tr key={s.id} style={S.tr}>
                <td style={S.td}>{s.client}</td>
                <td style={S.td}>{s.description || "—"}</td>
                <td style={{ ...S.td, fontWeight: 700, color: S.colors.primary }}>{fmt(s.amount)}</td>
                <td style={S.td}>{dispDate(s.date)}</td>
                <td style={S.td}>
                  <button style={{ ...S.smallBtn, ...S.deleteBtn }} onClick={() => del("sales", s.id)}>✕</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
